module.exports = __webpack_public_path__ + "img/desk4.e930a6d2.png";